import React, { useState } from 'react';
import axios from 'axios';

const ImageUpload = () => {
 const [selectedFile, setSelectedFile] = useState(null);

 const handleFileChange = (e) => {
  setSelectedFile(e.target.files[0]);
 };

 const handleFileUpload = async () => {
  if (selectedFile) {
   const formData = new FormData();
   formData.append('file', selectedFile);

   try {
    const response = await axios.post(
     'http://localhost/custom_plugin/wp-json/custom/v1/mediaUpload', // Replace with your actual endpoint
     formData,
     {
      headers: {
       'Content-Type': 'multipart/form-data',
      },
     }
    );

    console.log('File uploaded successfully:', response.data.message);
   } catch (error) {
    console.error('Error uploading file:', error.response.data.message);
   }
  } else {
   console.error('No file selected.');
  }
 };

 return (
  <div>
   <input type="file" onChange={handleFileChange} />
   <button onClick={handleFileUpload}>Upload File</button>
  </div>
 );
};

export default ImageUpload;
